import axios from "axios";

import { updateReportScore } from "./updateReport";

// const API_URL = 'http://localhost/games/national_hiest_reactAPI/api/ScoreApi.php';
const API_URL = process.env.REACT_APP_PHP_SCORE_ADD_URL;


// const API_URL = process.env.REACT_APP_PHP_SCORE_ADD_URL; // update to your PHP path
console.log("API_URL",API_URL);

// Insert Score (PHP checks for duplicate automatically)
export const insertScore = async (data) => {
  try {
    console.log("final-data",data);
    const response = await axios.post(API_URL, {
      action: "insert",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Insert error:", err);
    return { status: "error", message: err.message };
  }
};
export const alreadyPlayed = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "check",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Insert error:", err);
    return { status: "error", message: err.message };
  }
};

// Update Score (no need for record id anymore)
export const updateScore = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "update",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};
// Update Score (no need for record id anymore)
// export const updateReport = async (data) => {
//   try {
//     const response = await axios.post(API_URL, {
//       action: "updatereport",
//       ...data,
//     }, {
//       headers: { "Content-Type": "application/json" },
//     });

//     return response.data;
//   } catch (err) {
//     console.error("Update error:", err);
//     return { status: "error", message: err.message };
//   }
// };

export const updateReport = async (data) => {
  try {
    const response = await axios.post(
      API_URL,
      {
        action: "updatereport",
        ...data,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    const result = response.data;

    // ✅ Check PHP success response
    if (result.status === "success") {
      await updateReportScore({
        token: data.token || '',
        reportId: data.reportId,
        points: data.score,
        time: "00:"+data.time,
        roles: data.roles,
      });
    }

    return result;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};


export const updatereportId = async (data) => {
  try {
    const response = await axios.post(
      API_URL,
      {
        action: "updatereportId",
        ...data,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    const result = response.data;

   
    return result;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const fetchQuestions = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "fetchQuestions",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const fetchCurrentQuestion = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "fetchCurrentQuestion",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const UpdaterGameover = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "updategameover",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const fetchReport = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "fetch",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Insert error:", err);
    return { status: "error", message: err.message };
  }
};

// export const fetchAllStages = async (data) => {
//   try {
//     const response = await axios.post(API_URL, {
//       action: "fetch_all_stages",
//       ...data,
//     }, {
//       headers: { "Content-Type": "application/json" },
//     });

//     return response.data;
//   } catch (err) {
//     console.error("Insert error:", err);
//     return { status: "error", message: err.message };
//   }
// };



export const fetchAllStages = async (data) => {
  try {
    console.log("📤 fetchAllStages payload:", data);

    const response = await axios.post(API_URL, {
      action: "fetch_all_stages",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    console.log("📥 fetchAllStages raw response:", response);
    console.log("📥 fetchAllStages data:", response.data);

    return response.data;
  } catch (err) {
    console.error("🔥 fetchAllStages error:", err);
    return { status: "error", message: err.message };
  }
};
